import React, { useEffect, useState } from "react";
import SelectField from "../../../../Components/SelectField";
import { CircularProgress } from "@mui/material";
import { allEmployeeURL } from "../../../../Library/URLs";
import { v4 as uuid } from "uuid";
import axios from "axios";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const LeaveSettings = ({
  leaveSettings,
  setLeaveSetting,
  updateSettings,
  isLoading,
}) => {
  const unique_id = uuid();
  const User = useSelector((state) => state.payroll.User);
  const { companyid } = useParams();
  const [allEmployees, setAllEmployees] = useState([]);

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);

  const fetch = async () => {
    // console.log('all employee API is call')
    const raw = {
      user_id: User.user_id,
      user_ses_id: User.user_ses_id,
      transaction_id: unique_id,
      company_id: companyid,
    };
    await axios
      .post(allEmployeeURL, raw)
      .then((res) => {
        if (res.data.success === true) {
          // setAllEmployees(res.data.data);
          const itemres = res.data.data?.map((item) => {
            return {
              label: `${item?.first_name} ${item?.middle_name} ${item?.last_name}`,
              value: item?.id,
            };
          });
          setAllEmployees(itemres);
        }

        // console.log('length',res.data.employees.length)
      })
      .catch((err) => {
        // console.log('error'+err.message)
      });
  };
  const assignFirstLevel = (value) => {
    let assignListCopy = [...leaveSettings?.approvers];
    if (assignListCopy?.length > 0) {
      assignListCopy[0] = {
        level: "1",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "1", employee_id: value });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignListCopy });
  };

  const assignSecondLevel = (value) => {
    let assignListCopy = [...leaveSettings?.approvers];
    if (assignListCopy?.length > 1) {
      assignListCopy[1] = {
        level: "2",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "2", employee_id: value });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignListCopy });
  };

  const assignThirdLevel = (value) => {
    let assignListCopy = [...leaveSettings?.approvers];
    if (assignListCopy?.length > 2) {
      assignListCopy[2] = {
        level: "3",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "3", employee_id: value });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignListCopy });
  };

  const assignFourthLevel = (value) => {
    let assignListCopy = [...leaveSettings?.approvers];
    if (assignListCopy?.length > 3) {
      assignListCopy[3] = {
        level: "4",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "4", employee_id: value });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignListCopy });
  };

  const assignFifthLevel = (value) => {
    let assignListCopy = [...leaveSettings?.approvers];
    if (assignListCopy?.length > 1) {
      assignListCopy[4] = {
        level: "5",
        employee_id: value,
      };
    } else {
      assignListCopy.push({ level: "5", employee_id: value });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignListCopy });
  };

  const addApprover = () => {
    let assignedLength = leaveSettings?.approvers?.length;
    let assignedListCopy = [...leaveSettings?.approvers];
    if (assignedLength === 0) {
      assignedListCopy.push({
        level: "1",
        employee_id: "",
      });
    } else if (assignedLength === 1) {
      assignedListCopy.push({
        level: "2",
        employee_id: "",
      });
    } else if (assignedLength === 2) {
      assignedListCopy.push({
        level: "3",
        employee_id: "",
      });
    } else if (assignedLength === 3) {
      assignedListCopy.push({
        level: "4",
        employee_id: "",
      });
    } else if (assignedLength === 4) {
      assignedListCopy.push({
        level: "5",
        employee_id: "",
      });
    }
    setLeaveSetting({ ...leaveSettings, approvers: assignedListCopy });
  };

  const removeApprover = (id) => {
    let assignedListCopy = [...leaveSettings?.approvers];
    assignedListCopy.pop();
    // assignedListCopy?.splice(id, 1);
    setLeaveSetting({ ...leaveSettings, approvers: assignedListCopy });
  };

  const handleChange = (id, value) => {
    if (id === 0) {
      assignFirstLevel(value);
    } else if (id === 1) {
      assignSecondLevel(value);
    } else if (id === 2) {
      assignThirdLevel(value);
    } else if (id === 3) {
      assignFourthLevel(value);
    } else if (id === 4) {
      assignFifthLevel(value);
    }
  };

  const dashboardTheme = window.localStorage.getItem("theme");

  return (
    <div>
      <p style={{ marginBottom: "1rem" }}>Leave Settings</p>
      <div
        className="Acc_Content_Wrap"
        style={{ margin: "1rem 0", gap: "2rem" }}
      >
        <div className="Box">
          <label htmlFor="">Require Approval</label>
          <select
            className="input_full"
            value={leaveSettings?.require_approval}
            onChange={(e) =>
              setLeaveSetting({
                ...leaveSettings,
                require_approval: e.target.value,
              })
            }
          >
            <option value="" hidden>
              Choose
            </option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div
        className="Acc_Content_Wrap"
        style={{ margin: "1rem 0", gap: "2rem" }}
      >
        <div className="Box">
          <label htmlFor="">Enforce Leave Rules</label>
          <select
            className="input_full"
            value={leaveSettings?.enforce_leave_rules}
            onChange={(e) =>
              setLeaveSetting({
                ...leaveSettings,
                enforce_leave_rules: e.target.value,
              })
            }
          >
            <option value="" hidden>
              Choose
            </option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>

      {leaveSettings.enforce_leave_rules === "Yes" && (
        <div
          className="Acc_Content_Wrap"
          style={{ margin: "1rem 0", gap: "2rem" }}
        >
          <div className="Box">
            <label htmlFor="">Leave Overlapping Group</label>
            <select
              className="input_full"
              value={leaveSettings?.leave_overlapping_group}
              onChange={(e) =>
                setLeaveSetting({
                  ...leaveSettings,
                  leave_overlapping_group: e.target.value,
                })
              }
            >
              <option value="" hidden>
                Choose group
              </option>
              <option value="All Employees">All Employees</option>
              <option value="Specific Employee">Specific Employees</option>
              <option value="Business Unit">Business Unit</option>
              <option value="Business Unit">Business Unit</option>
              <option value="Division">Division</option>
              <option value="Department">Department</option>
              <option value="Pay Grade">Pay Grade</option>
              <option value="Pay Level">Pay Level</option>
              <option value="Location">Location</option>
            </select>
          </div>
        </div>
      )}
      {leaveSettings.enforce_leave_rules === "Yes" && (
        <div
          className="Acc_Content_Wrap"
          style={{ margin: "1rem 0", gap: "2rem" }}
        >
          <div className="Box">
            <label htmlFor="">Overlapping Limit</label>
            <input
              className="input_full"
              value={leaveSettings?.overlapping_limit}
              onChange={(e) =>
                setLeaveSetting({
                  ...leaveSettings,
                  overlapping_limit: e.target.value,
                })
              }
            />
          </div>
        </div>
      )}

      {leaveSettings?.approvers?.map((item, id) => (
        <div className="Pay_Row_Wrap" key={id}>
          <label htmlFor="">Level {id + 1} approver</label>
          <span className="Payroll_approver">
            <SelectField
              name="foundational_obj"
              onChange={(e) => handleChange(id, e.value)}
              options={allEmployees}
              value={allEmployees?.find(
                (employee) => employee?.value === item?.employee_id
              )}
            />
          </span>
        </div>
      ))}
      {leaveSettings?.approvers?.length < 5 && (
        <button onClick={addApprover} className="add_approve">
          Add {leaveSettings?.approvers?.length > 0 && "Another"} Approver (
          {5 - leaveSettings?.approvers?.length} left)
        </button>
      )}
      <div className="Payroll_Btn_contain">
        <button
          className="Payroll_app_edit"
          onClick={updateSettings}
          style={{
            backgroundColor: dashboardTheme ? dashboardTheme : "#13ABF4",
          }}
        >
          {isLoading === false ? (
            "Update"
          ) : (
            <CircularProgress color="inherit" size={14} />
          )}
        </button>
        <button onClick={() => removeApprover()} className="Btn_remove_payroll">
          Remove
        </button>
      </div>
    </div>
  );
};

export default LeaveSettings;
